var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavTodoActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D1C8864-64E1-4F39-9E57-DEA7D0CE48FE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -282.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 271.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavTodo",
    transform: "translate(18.000000, 282.000000)",
    fill: "#898381",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.998,15 L18.998,15 L18.998,14 C18.998,12.346 17.653,11 16,11 L13,11 L13,9 L15,9 C15.5522847,9 16,8.55228475 16,8 L16,3 C16,2.44771525 15.5522847,2 15,2 L9,2 C8.44771525,2 8,2.44771525 8,3 L8,8 C8,8.55228475 8.44771525,9 9,9 L11,9 L11,11 L8,11 C6.346,11 5,12.346 5,14 L5,15 L3,15 C2.44771525,15 2,15.4477153 2,16 L2,21 C2,21.5522847 2.44771525,22 3,22 L9,22 C9.55228475,22 10,21.5522847 10,21 L10,16 C10,15.4477153 9.55228475,15 9,15 L7,15 L7,14 C7,13.449 7.449,13 8,13 L16,13 C16.5515035,13.001103 16.9980011,13.4484954 16.998,14 L16.998,15 L15,15 C14.4477153,15 14,15.4477153 14,16 L14,21 C14,21.5522847 14.4477153,22 15,22 L20.998,22 C21.5502847,22 21.998,21.5522847 21.998,21 L21.998,16 C21.998,15.4477153 21.5502847,15 20.998,15 Z M10,7 L10,4 L14,4 L14,7 L10,7 Z M8,20 L4,20 L4,17 L8,17 L8,20 Z M19.998,20 L16,20 L16,17 L19.998,17 L19.998,20 L19.998,20 Z",
    id: "Solid"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTodoActive);
export default __webpack_public_path__ + "static/media/NavTodoActive.2bcbce8b68590c77f59cdef68ae76881.svg";
export { ForwardRef as ReactComponent };